import { Injectable } from '@angular/core';

import {
  DataLayerService,
  IAddPaymentInfoPayload,
  IAddShippingInfoPayload,
  IAddToCartPayload, IAuthTrackPayload, ICart, ICartLine,
  IVirtualPageViewPayload,
  PostHogTrackerService
} from '@cakeiteasy/order-process';

import { IOrder, IProductType } from '@cakeiteasy/web-utils';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class AnalyticTracker {
  previousUrl = '';

  constructor(private dataLayer: DataLayerService,
              private postHogTracker: PostHogTrackerService,
              private router: Router) {
  }


  /**This method is evoked in CartServiceV2 via CART_ANALYTIC_TRACKERS*/
  async trackRemoveFromCart(cart: ICart, lines: ICartLine[]): Promise<void> {
    try {
      await Promise.all([
        this.dataLayer.trackRemoveFromCart(cart, lines),
        this.postHogTracker.trackRemoveFromCart(cart, lines),
      ]);
    } catch (error) {
      console.error('AnalyticTracker trackRemoveFromCart error:', error);
    }
  }

  /**This method is evoked in CartBtnQuantityPriceComponent via CART_ANALYTIC_TRACKERS*/
  async trackViewCart(cart: ICart): Promise<void> {
    try {
      await Promise.all([
        this.dataLayer.trackViewCart(cart),
        this.postHogTracker.trackViewCart(cart),
      ]);
    } catch (error) {
      console.error('AnalyticTracker trackRemoveFromCart error:', error);
    }
  }

  async trackSearchNoResult(payload: { searchTerm: string, pageLocation: string, }): Promise<void> {
    try {
      await Promise.all([
        this.dataLayer.trackSearchNoResult(payload),
        this.postHogTracker.trackSearchNoResult(payload),
      ]);
    } catch (error) {
      console.error('trackSearchNoResult error:', error);
    }
  }

  async trackSearch(payload: { searchTerm: string, pageLocation: string, }): Promise<void> {
    try {
      await Promise.all([
        this.dataLayer.trackSearch(payload),
        this.postHogTracker.trackSearch(payload),
      ]);
    } catch (error) {
      console.error('trackSearch error:', error);
    }
  }

  async trackVirtualPageView(pageTitle: string): Promise<void> {
    try {
      const pageFullUrl = this.router.url;
      const payload = { pageTitle, pageFullUrl, previousUrl: this.previousUrl };

      await Promise.all([
        this.dataLayer.trackVirtualPageView(payload),
        this.postHogTracker.trackVirtualPageView(payload),
      ]);

      this.previousUrl = pageFullUrl;
    } catch (error) {
      console.error('trackVirtualPageView error:', error);
    }
  }

  async trackAddToCart(payload: IAddToCartPayload): Promise<void> {
    try {
      await Promise.all([
        this.dataLayer.trackAddToCart(payload),
        this.postHogTracker.trackAddToCart(payload),
      ]);
    } catch (error) {
      console.error('trackAddToCart error:', error);
    }
  }

  async trackViewItem(product: IProductType): Promise<void> {
    try {
      await Promise.all([
        this.dataLayer.trackViewItem(product),
        this.postHogTracker.trackViewItem(product),
      ]);
    } catch (error) {
      console.error('trackViewItem error:', error);
    }
  }

  async trackAddPaymentInfo(payload: IAddPaymentInfoPayload): Promise<void> {
    try {
      await Promise.all([
        this.dataLayer.trackAddPaymentInfo(payload),
        this.postHogTracker.trackAddPaymentInfo(payload),
      ]);
    } catch (error) {
      console.error('trackAddPaymentInfo error:', error);
    }
  }

  async trackOrderPurchase(order: IOrder): Promise<void> {
    try {
      await Promise.all([
        this.dataLayer.trackOrderPurchase(order),
        this.postHogTracker.trackOrderPurchase(order),
      ]);
    } catch (error) {
      console.error('trackOrderPurchase error:', error);
    }
  }

  async trackAddShippingInfo(payload: IAddShippingInfoPayload): Promise<void> {
    try {
      await Promise.all([
        this.dataLayer.trackAddShippingInfo(payload),
        this.postHogTracker.trackAddShippingInfo(payload),
      ]);
    } catch (error) {
      console.error('trackAddShippingInfo error:', error);
    }
  }

  async trackBeginCheckout(payload: IAddShippingInfoPayload): Promise<void> {
    try {
      await Promise.all([
        this.dataLayer.trackBeginCheckout(payload),
        this.postHogTracker.trackBeginCheckout(payload),
      ]);
    } catch (error) {
      console.error('trackBeginCheckout error:', error);
    }
  }

  async trackLogin(payload: IAuthTrackPayload): Promise<void> {
    try {
      await Promise.all([
        this.dataLayer.trackLogin(payload),
        this.postHogTracker.trackLogin(payload),
      ]);
    } catch (error) {
      console.error('trackLogin error:', error);
    }
  }

  async trackSignUp(payload: IAuthTrackPayload): Promise<void> {
    try {
      await Promise.all([
        this.dataLayer.trackSignUp(payload),
        this.postHogTracker.trackSignUp(payload),
      ]);
    } catch (error) {
      console.error('trackSignUp error:', error);
    }
  }


  async trackLogout() {
    try {
      await Promise.all([
        this.dataLayer.trackLogout(),
        this.postHogTracker.trackLogout(),
      ]);
    } catch (error) {
      console.error('trackLogout error:', error);
    }
  }
}
